var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-sm font-medium text-gray-500 mb-1"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"text-base text-gray-800 dark:text-white"},[_vm._v(_vm._s(_vm.value || '—'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }